/**
 * (c) 2024, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
export const previewGraphData = {
  x: [
    0.588, 1.156, 1.156, 1.82, 1.804, 1.804, 1.46, 1.168, 1.048, 0.828, 0.128,
    0.128, -0.128, -0.552, -0.552, -0.712, -0.536, -0.536, -0.428, -0.14, -0.14,
    0.032, 0.292, 0.292, 0.324, 0.464, 0.464, 0.92, 2.04, 2.04, 2.024, 1.428,
    1.136, 0.928, 0.668, 0.492, 0.308, -0.124, -0.312, -0.4, -0.58, -0.488,
    -0.372, -0.224, -0.052, 0.104, 0.204, 0.284, 0.324,
  ],
  y: [
    -0.876, -1.128, -1.128, -1.472, -1.504, -1.504, -1.404, -1.132, -0.936,
    -0.76, -0.056, -0.056, 0.276, 1.424, 1.424, 1.552, 1.204, 1.204, 1.304,
    1.132, 1.132, 0.688, 0.104, 0.104, -0.148, -0.692, -0.692, -1.096, -1.804,
    -1.804, -1.576, -1.356, -1.068, -0.88, -0.7, -0.412, -0.136, 0.324, 0.92,
    1.5, 1.68, 1.288, 1.104, 1.08, 0.948, 0.712, 0.348, 0.104, -0.256,
  ],
  z: [
    0.156, 0.392, 0.392, 0.452, 0.468, 0.468, 0.332, 0.232, 0.108, -0.14, 0.332,
    0.332, 0.292, 0.152, 0.152, 0.216, 0.056, 0.056, 0.012, 0.188, 0.188, 0.132,
    0.228, 0.228, 0.208, 0.092, 0.092, 0.128, 0.3, 0.3, 0.34, 0.144, 0.184,
    0.148, -0.016, -0.224, -0.236, 0.1, 0.172, 0.012, 0.164, 0.18, 0.2, 0.268,
    0.34, 0.372, 0.32, 0.268, 0.12,
  ],
};
